import { render, staticRenderFns } from "./portfoliocomparetable.vue?vue&type=template&id=8f5d5b30&scoped=true&"
import script from "./portfoliocomparetable.vue?vue&type=script&lang=js&"
export * from "./portfoliocomparetable.vue?vue&type=script&lang=js&"
import style0 from "./portfoliocomparetable.vue?vue&type=style&index=0&id=8f5d5b30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5d5b30",
  null
  
)

export default component.exports